import React, { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from 'plume-ui';
import {
  OutreachConfigGenericFormField,
  OutreachConfigSections,
  OutreachTimeFormFields,
} from '../../../../../types';
import OutreachConfigSection from '../../../OutreachConfigSection';
import { Maybe } from '../../../../../../../types';
import useValidation from '../../../hooks/useValidation';
import useTimeFieldActions from '../../../hooks/useTimeFieldActions';
import { Permission } from '../../../../../../../userPermissionConfig';
import { useFeaturePermission } from '../../../../../../../hooks/useFeaturePermission';

export type FormikOutreachSupportTimeValue = {
  from: Maybe<Date> | null;
  to: Maybe<Date> | null;
};

const FormikOutreachSupportTimeFieldWebhook: FunctionComponent<OutreachConfigGenericFormField<
  FormikOutreachSupportTimeValue
>> = ({ field, form }) => {
  const { t } = useTranslation();
  const { hasPermission } = useFeaturePermission();
  const { isSectionComplete } = useValidation();
  const { renderDropdownFor } = useTimeFieldActions(field, form);
  const isComplete = isSectionComplete(
    OutreachConfigSections.SupportOutreachTimeWebhook,
  );
  const canEditSupportWebhook = hasPermission(
    Permission.EditSupportWebhookOutreach,
  );

  const titleCopyId = 'outreach.form.supportOutreachTimeSection.titleWebhook';
  const subtitleCopyId =
    'outreach.form.supportOutreachTimeSection.subtitleWebhook';
  return (
    <OutreachConfigSection
      title={t(titleCopyId)}
      subtitle={t(subtitleCopyId)}
      isRequired
      isComplete={isComplete}
      isOpen={canEditSupportWebhook}
    >
      <div className="OutreachContainer__subscriber-outreach-time-row">
        {renderDropdownFor(OutreachTimeFormFields.From)}
        <Divider
          classes={(current) => ({
            ...current,
            root: `${current.root} OutreachContainer__subscriber-outreach-time-divider`,
          })}
        />
        {renderDropdownFor(OutreachTimeFormFields.To)}
      </div>
    </OutreachConfigSection>
  );
};

export default memo(FormikOutreachSupportTimeFieldWebhook);
